import { Injectable, inject } from '@angular/core';
import { HttpService } from '../servicios/http.service';
import { ICoordenadas } from 'modelos/src';
import { Observable } from 'rxjs';
import { PAIS } from 'src/environments/contantes';
import { HttpApiAdminService } from '../servicios/http-api.service';

@Injectable({
  providedIn: 'root',
})
export class MarkerLocationService {
  private http = inject(HttpApiAdminService);

  public direcciones(
    text: string,
    coordenadas?: ICoordenadas,
  ): Observable<{ resultados: string[] }> {
    return this.http.post(`/geocode/direcciones`, { text, PAIS, coordenadas });
  }

  public geocode(text: string): Observable<ICoordenadas> {
    return this.http.post(`/geocode/geocode`, { text });
  }
}
